import { render, staticRenderFns } from "./Newyear.vue?vue&type=template&id=73e78431&scoped=true&"
import script from "./Newyear.vue?vue&type=script&lang=js&"
export * from "./Newyear.vue?vue&type=script&lang=js&"
import style0 from "./Newyear.vue?vue&type=style&index=0&id=73e78431&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "73e78431",
  null
  
)

export default component.exports